import { useQuery } from '@tanstack/react-query';
import useWorkspaceSelected from 'Hooks/useWorkspaceSelected';
import { getInvoiceTaxes } from 'Services/invoices';
import { trackError } from 'Utils/errorMonitoring';

const ticketbaiExcludedGroups = ['ESP_IGIC', 'ESP_IPSI_C', 'ESP_IPSI_M'];

export default function useInvoiceTaxes(visibleTaxIds = [], options = {}) {
    const { data: invoiceTaxes = [], isLoading } = useQuery({
        queryKey: ['invoice-taxes'],
        queryFn: getInvoiceTaxes,
        onError: (error) => trackError(error),
        ...options,
    });

    const { workspace } = useWorkspaceSelected();

    const getGroupName = (groupId) => {
        const group = invoiceTaxes.find((tax) => tax.group === groupId);
        return group ? group.group_name : '';
    };

    const getTaxGroupId = (taxId) => {
        const tax = invoiceTaxes.find((tax) => tax.id === taxId);
        return tax ? tax.group : null;
    };

    const getTaxById = (taxId) => {
        return invoiceTaxes.find((tax) => tax.id === taxId) || null;
    };

    const filteredTaxes = invoiceTaxes.filter((tax) => {
        if (visibleTaxIds.includes(tax.id)) {
            return true;
        }

        if (tax.country !== 'ESP') {
            return false;
        }

        if (workspace?.tax_authority === 'ticketbai') {
            return !ticketbaiExcludedGroups.includes(tax.group);
        }

        return true;
    });

    return {
        invoiceTaxes: filteredTaxes,
        allInvoiceTaxes: invoiceTaxes,
        isLoading,
        getGroupName,
        getTaxGroupId,
        getTaxById,
    };
}
